// @flow
import type { CategoryT } from "Commons/Modules/category/misc/Types.js";

export const sortCategories = (a: CategoryT, b: CategoryT) => {
  return b.sortPriority - a.sortPriority;
};
